import React from 'react';
import PropTypes from 'prop-types';
import { loadReCaptcha } from 'react-recaptcha-v3';
import gettext from '@eb/gettext';

import { Button } from '@eb/eds-button';

import LoginForm from '../../components/newForms/LoginForm';

export default class EventbriteLoginOptions extends React.Component {
    static propTypes = {
        onLogInUser: PropTypes.func,
        clearAuthNotification: PropTypes.func,
        onLookupUser: PropTypes.func,
        handleClickViewPassword: PropTypes.func,
    };

    componentDidMount() {
        if (!this.props.disableRecaptcha3) {
            loadReCaptcha(this.props.recaptcha3PublicKey);
        }
    }

    _handleSubmit = (formData) => {
        const { clearAuthNotification, onLogInUser } = this.props;
        // clear notification  everytime form is submitted
        if (clearAuthNotification) {
            clearAuthNotification();
        }
        return onLogInUser(formData);
    };
    //When user clicks on view password
    _handleOnIconClick = () => {
        const { handleClickViewPassword } = this.props;
        if (handleClickViewPassword) {
            handleClickViewPassword();
        }
    };

    render() {
        const {
            buttonCTA,
            handleShowNotification,
            handleClearNotification,
            handleSignUpClick,
            onLookupUser,
            clearAuthNotification,
            handleForgotPassword,
            handleClickViewPassword,
            recaptcha2PublicKey,
            recaptcha3PublicKey,
            disableRecaptcha3,
            showCaptcha,
            isAccountExistent,
        } = this.props;
        return (
            <div data-automation="eventbrite-login-section">
                <LoginForm
                    buttonCTA={buttonCTA}
                    onSubmit={this._handleSubmit}
                    onLookupUser={onLookupUser}
                    clearAuthNotification={clearAuthNotification}
                    handleForgotPassword={handleForgotPassword}
                    recaptcha2PublicKey={recaptcha2PublicKey}
                    recaptcha3PublicKey={recaptcha3PublicKey}
                    disableRecaptcha3={disableRecaptcha3}
                    showCaptcha={showCaptcha}
                    showNotification={handleShowNotification}
                    clearNotification={handleClearNotification}
                    isAccountExistent={isAccountExistent}
                    handleClickViewPassword={handleClickViewPassword}
                />

                <div className="eds-text-color--ui-800 eds-text-weight--heavy eds-l-pad-bot-4">
                    <span className="eds-l-pad-right-1">
                        {gettext("Don't have an account?")}
                    </span>

                    <Button
                        onClick={handleSignUpClick}
                        type="button"
                        style="anchor"
                        data-automation="go-to-signup"
                    >
                        {gettext('Create an account')}
                    </Button>
                </div>
            </div>
        );
    }
}
